import { ColumnProps } from '../types/CustomColumns';

export const defaultColumns: ColumnProps[] = [
  { id: 'sector', label: 'Sector', display: true, order: 0 },
  { id: 'fitScore', label: 'Fit Score', display: true, order: 1 },
  { id: 'ups', label: 'USP', display: true, order: 2 },
  { id: 'tech', label: 'Tech', display: true, order: 3 },
  { id: 'patents', label: 'Patents', display: true, order: 4 },
  { id: 'team', label: 'Team', display: true, order: 5 },
  { id: 'dataCoverage', label: 'Data Coverage', display: true, order: 6 },
  { id: 'risks', label: 'Risks', display: true, order: 7 },
];

/**
 * Returns a safe, validated array of columns from user preferences or defaultColumns.
 */
export function getSavedColumns(tablePreferences: ColumnProps[] | undefined) {
  if (tablePreferences && tablePreferences.length > 0) {
    // Filter out undefined/null and ensure id is a string
    const filtered = tablePreferences.filter(
      (col): col is ColumnProps => !!col && typeof col.id === 'string'
    );
    if (filtered.length > 0) {
      return [...filtered].sort((a, b) => a.order - b.order);
    }
  }
  return defaultColumns;
}
